export enum DeleteOrganizationTenantResultType {
    Success = 'The tenant was unlinked successfully.',
    Invalid = 'The tenant configuration was invalid.',
    Unauthorized = 'You are unauthorized to unlink this tenant.',
    Unknown = 'An unknown error has occurred. Please try again.',
    Timeout = `The tenant couldn't be unlinked because the request took too long.`
}
